import validator from "validator";
import message from "../../../messages/site-user-advertiser/add";

const validateFormAddSiteUserAdvertiser = (webSiteUrl) => {
  if (!(webSiteUrl.includes("http://") || webSiteUrl.includes("https://"))) {
    console.log("11")
    return {
      status: false,
      message: message.URL_DOES_NOT_HAVE_PROTOCOL,
    };
  }

  if (webSiteUrl.includes("http://")) {
    console.log("22")
    webSiteUrl = webSiteUrl.replace("http://", "");
  } else {
    webSiteUrl = webSiteUrl.replace("https://", "");
  }

  if (webSiteUrl.includes("/")) {
    console.log("33")
    return {
      status: false,
      message: message.URL_HAS_FORWARD_SLASH,
    };
  }

  if (!validator.isURL(webSiteUrl)) {
    console.log("44")
    return {
      status: false,
      message: message.URL_IS_INVALID,
    };
  }
  console.log("55")
  return {
    status: true,
  }
};

export default validateFormAddSiteUserAdvertiser;
